var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-headful',{attrs:{"title":_vm.site_title}}),(_vm.response && this.response.threadId)?[_vm._v(" Thread found, redirecting... ")]:[_vm._v(" "+_vm._s(_vm.response)+" ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }